import ReactDOM from 'react-dom/client';
import { Navigate, Route } from 'react-router-dom';
import './index.css';
import { ContactPage } from './pages/Contact';
import { LegalPage } from './pages/Legal/Legal';
import { LoginPage } from './pages/Auth/Login';
import { themeResolver } from './resolvers/themeResolver';
import { RootTemplate } from './templates/RootTemplate';
import { HomePage } from './pages/Home';
import { PropsWithChildren } from 'react';
import { ProfilePage } from './pages/Profile/Profile';
import { NotificationPage } from './pages/Notifications/Notifications';
import * as Sentry from '@sentry/react';
import { SearchPage } from './pages/Search';
import { BenefitsPage } from './pages/Benefits/Benefits';
import { DealsPage } from './pages/Deals/Deals';
import { DealsDetailsPage } from './pages/DealsDetails/DealsDetails';
import { FavoritesPage } from './pages/Favorites/Favorites';
import { OrderHistoryPage } from './pages/OrderHistory/OrderHistory';
import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Partner } from './pages/Profile/components/Partner';
import { FormPartner } from './pages/Partner/FormPartner';
import { RecoveryPage } from './pages/Auth/RecoveryPage';
import { TelemedicineSchedulePage } from './pages/Telemedicine/TelemedicineSchedule';
import { FaturaPage } from './pages/Fatura/Fatura';
import { browserTracingIntegration } from '@sentry/react';
import { ProtectedRoute } from './contexts/ProtectedRoute';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels, ArcElement);

ChartJS.defaults.set('plugins.datalabels', {
  backgroundColor: '#dedede',
  borderRadius: 5,
  font: {
    size: 10,
  },
});

function ClubProtectedRoute({ children }: PropsWithChildren) {
  return (
    <ProtectedRoute loginPage="/login" showToast={false}>
      {children}
    </ProtectedRoute>
  );
}

if (process.env.REACT_APP_SENTRY_ENVIRONMENT === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? '0.0') || 0.0,
    release: process.env.REACT_APP_SENTRY_RELEASE || 'unknown-release',
    integrations: [browserTracingIntegration()],
    beforeSend(event) {
      if (event.exception) {
        const exception = event.exception.values?.[0];
        if (exception?.type === 'NotFoundError' && exception?.value?.includes('removeChild')) {
          return null;
        }
      }
      return event;
    },
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <RootTemplate themeResolver={themeResolver}>
    <Route path={'/login'} element={<LoginPage />} />
    <Route path={'/recuperar'} element={<RecoveryPage />} />
    <Route path={'/'} element={<HomePage />} />
    <Route path={'/telemedicina'} element={<TelemedicineSchedulePage />} />
    <Route path={'/vantagens'} element={<DealsPage />} />
    <Route path={'/vantagens/detalhes/:mode/:id'} element={<DealsDetailsPage />} />
    <Route path={'/beneficios'} element={<BenefitsPage />} />
    <Route path={'/busca'} element={<SearchPage />} />
    <Route path={'/parcerias'} element={<Partner />} />
    <Route path={'/cadastro-parcerias'} element={<FormPartner />} />
    <Route
      path={'/central-do-cliente'}
      element={
        <ClubProtectedRoute>
          <FaturaPage />
        </ClubProtectedRoute>
      }
    />
    <Route
      path={'/notificacoes'}
      element={
        <ClubProtectedRoute>
          <NotificationPage />
        </ClubProtectedRoute>
      }
    />
    {/* <Route
      path={'/compras'}
      element={
        <ClubProtectedRoute>
          <ShoppingPage />
        </ClubProtectedRoute>
      }
    /> */}
    <Route
      path={'/perfil/*'}
      element={
        <ClubProtectedRoute>
          <ProfilePage />
        </ClubProtectedRoute>
      }
    />
    <Route
      path={'/favoritos'}
      element={
        <ClubProtectedRoute>
          <FavoritesPage />
        </ClubProtectedRoute>
      }
    />
    <Route
      path={'/historico'}
      element={
        <ClubProtectedRoute>
          <OrderHistoryPage />
        </ClubProtectedRoute>
      }
    />
    <Route path={'/legal/*'} element={<LegalPage />} />
    <Route path={'/contato'} element={<ContactPage />} />
    <Route path={'*'} element={<Navigate to="/" />} />
  </RootTemplate>
);
